import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cleanVehicleActions, getVehicleAction } from '../../redux/actions/vehicleActions';

const useFetchVehicle = (vin) => {
  const dispatch = useDispatch();
  const vehicle = useSelector((state) => state.vehicle?.vehicle);
  const loading = useSelector((state) => state.vehicle?.loading);

  const fetchVehicle = useCallback(async () => {
    await dispatch(getVehicleAction(vin));
  }, [vin, dispatch]);

  useEffect(() => {
    fetchVehicle();
  }, [fetchVehicle]);

  useEffect(() => {
    return () => {
      dispatch(cleanVehicleActions());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVehicle();
  };

  return { loading, vehicle, refresh };
};

export default useFetchVehicle;
